import React from "react";
import PropTypes from "prop-types";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import RegularMenuItem from "./regularMenuItem";
import OverflowMenuItem from "./overflowMenuItem";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const PaperStyled = styled(Paper)(({ theme }) => ({
  width: "180px",
  borderRadius: "0px 0px 4px 4px",
  borderRight: `1px solid ${theme.palette.grey250.main}`,
  borderBottom: `1px solid ${theme.palette.grey250.main}`,
  borderLeft: `1px solid ${theme.palette.grey250.main}`,
  boxShadow: "0px 3px 9px 0px rgba(183, 183, 183, 0.10)",
}));

const IconMenu = ({
  variant = "default", // "default" | "overflow"
  anchorEl,
  handleClose,
  open,
  actionDefs,
  selectedItems = [],
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      role={undefined}
      placement="bottom-start"
      transition
      disablePortal
      sx={{ zIndex: 1000 }}
    >
      {({ TransitionProps, placement }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin:
              placement === "bottom-start" ? "left top" : "left bottom",
          }}
        >
          <PaperStyled>
            <ClickAwayListener onClickAway={() => {}}>
              <MenuList
                autoFocusItem={open}
                id="composition-menu"
                aria-labelledby="composition-button"
                disablePadding
              >
                {actionDefs.map((actionDef, index) =>
                  variant === "default" ? (
                    <RegularMenuItem
                      key={index}
                      actionDef={actionDef}
                      disableBorder={index === actionDefs.length - 1}
                      closeMenu={handleClose}
                      selectedItems={selectedItems}
                    />
                  ) : (
                    <OverflowMenuItem
                      key={index}
                      actionDef={actionDef}
                      disableBorder={index === actionDefs.length - 1}
                      closeMenu={handleClose}
                      selectedItems={selectedItems}
                    />
                  )
                )}
              </MenuList>
            </ClickAwayListener>
          </PaperStyled>
        </Grow>
      )}
    </Popper>
  );
};

export default IconMenu;

IconMenu.propTypes = {
  // The variant of the icon menu
  variant: PropTypes.oneOf(["default", "overflow"]),
  // The anchor element of the icon menu
  anchorEl: PropTypes.object,
  // The close handler of the icon menu
  handleClose: PropTypes.func,
  // The open state of the icon menu
  open: PropTypes.bool,
  // The action definitions to be rendered
  actionDefs: PropTypes.array,
};
